module.exports = __webpack_public_path__ + "media/images/thank-you-2ea4af57da260ddd44f4eaf1c894a64b.jpg";